import {
  Id,
  Organization,
  Request,
  RequestAgencyStatus,
  RequestTicket,
  RequestTicketType,
  ResponseDataPaginate,
  Tenant
} from 'src/types'

export enum IssuancesActionTypes {
  GET_ISSUANCES = '@issuances/GET_ISSUANCES',
  GET_ISSUANCES_FAILURE = '@issuances/GET_ISSUANCES_FAILURE',
  GET_ISSUANCES_SUCCESS = '@issuances/GET_ISSUANCES_SUCCESS',
  SEND_ISSUANCE = '@issuances/SEND_ISSUANCE',
  SEND_ISSUANCE_FAILURE = '@issuances/SEND_ISSUANCE_FAILURE',
  SEND_ISSUANCE_SUCCESS = '@issuances/SEND_ISSUANCE_SUCCESS',
  SET_TICKETS_EMISSION = '@issuances/SET_TICKETS_EMISSION'
}

export type ResponseDataRequests = ResponseDataPaginate &
  ResponseDataRequestTotals & {
    requests: ResponseDataRequestsItem[]
    organizations: ResponseIssuesOrganization[]
  }

export interface ResponseDataRequestsItem {
  request_agency_id: Id
  request_id: Id
  request: Request & { organization_name: string }
  request_agency_number: Id
  organization_id: Id
  customer_tenant_id: Id
  customer_organization_id: Id
  status: RequestAgencyStatus
  request_agency_user_data: RequestAgencyUserData[]
}

export type RequestAgencyUserData = {
  request_agency_user_data_id: Id
  request_agency_id: Id
  request_agency_user_data_number: Id
  request_agency_emission: RequestAgencyEmission
  status: 'EMISSION_PENDING'
}

export type RequestAgencyEmission = {
  request_agency_emission_id: Id
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}
export type TicketEmissionStatus = 'ISSUED' | 'EMISSION_CANCELED'

export type TicketEmission = {
  eticket_code?: Id
  pending: boolean
  request_ticket_id: Id
  request_ticket_type: RequestTicketType
  request_ticket: RequestTicket
  status: TicketEmissionStatus
}

export type ResponseIssuesOrganization = Pick<
  Organization,
  | 'organization_id'
  | 'legal_name'
  | 'trade_name'
  | 'vat_number'
  | 'code'
  | 'organization_type'
  | 'preferred_language'
  | 'user_limit'
  | 'active'
  | 'created_on'
  | 'updated_on'
> &
  Pick<Tenant, 'tenant_id'>

export type IssuancesState = ResponseDataRequestTotals & {
  readonly error: string
  readonly filterOrganizationsId: string
  readonly filterRequestNumber: string
  readonly filterRequestTitle: string
  readonly filterStatus: string[]
  readonly filterTenantId: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly organizations: ResponseIssuesOrganization[]
  readonly sendIssuanceError: string
  readonly sendIssuanceLoading: boolean
  readonly ticketsEmission: TicketEmission[]
  readonly total_results: number
}
